/**
 * Türkiye Cumhuriyeti Kimlik Numarası doğrulama
 * TC Kimlik numarası 11 haneli sayı olmalı
 * @param tcNumber TC Kimlik numarası
 * @returns Geçerli ise true, değilse false
 */
export const validateTCNumber = (tcNumber: string): boolean => {
  // Sadece 11 haneli sayı kontrolü
  return tcNumber.length === 11 && /^\d+$/.test(tcNumber);
};

/**
 * Vergi Numarası doğrulama
 * Vergi numarası 10 haneli olmalı ve tüm karakterler rakam olmalı
 * @param taxNumber Vergi numarası
 * @returns Geçerli ise true, değilse false
 */
export const validateTaxNumber = (taxNumber: string): boolean => {
  return taxNumber.length === 10 && /^\d+$/.test(taxNumber);
};
